import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum DocumentExtensionContentComponentId {
    OntarioMdHealthReportManager_OrphansView = 0
}

interface IDocumentExtensionContentRegistryProps {
    selectedView: string;
}

class DocumentExtensionContentRegistry extends BaseComponentRegistry<DocumentExtensionContentComponentId, IDocumentExtensionContentRegistryProps> {}

const DocumentExtensionContentRegistryView = createRegistryListView(() => DocumentExtensionContentRegistry.getInstance());

export {
    DocumentExtensionContentComponentId,
    DocumentExtensionContentRegistry,
    DocumentExtensionContentRegistryView,
    IDocumentExtensionContentRegistryProps
};
